'use client';

import React from 'react'

// Hooks
import useClient from '@hooks/useClient';

// Components
import { Footer, Header } from "@src/components/century-21-page"
import { Hero, AboutCentury, AboutCenturyIndonesia } from "@src/components/about-us"

const Page = () => {
  return (
    <div>
      <Header />
      <Hero />
      <AboutCentury />
      <AboutCenturyIndonesia />
      <Footer />
    </div>
  )
}

export default function AboutUsClient() {
  const isClient = useClient()

  if (!isClient) return null;
  return <Page />
}
